import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.size === 'small')?_c(VChip,{staticClass:"pro-chip pa-3",attrs:{"color":"accent","x-small":""}},[_c('p',{staticClass:"my-0 pro-badge-small label"},[_vm._v("PRO")])]):(_vm.size === 'medium')?_c(VChip,{staticClass:"pro-chip",attrs:{"color":"accent","small":""}},[_c('p',{staticClass:"my-0 pro-badge-small label"},[_vm._v("PRO")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }